import { css } from 'aphrodite';
import { styleSheet } from './styles';

export interface TaxEstimateDisplayProps {
	taxAmount: number | null;
	onCalculateClick: () => void;
	onEditClick: () => void;
	formatCurrency?: (value: number) => string;
}

const defaultFormatCurrency = (value: number): string => {
	return value.toLocaleString('en-US', {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	});
};

export function TaxEstimateDisplay({
	taxAmount,
	onCalculateClick,
	onEditClick,
	formatCurrency = defaultFormatCurrency,
}: TaxEstimateDisplayProps) {
	if (taxAmount === null) {
		return (
			<button className={css(styleSheet.link)} onClick={onCalculateClick} type='button'>
				[Click to calculate]
			</button>
		);
	}

	return (
		<span className={css(styleSheet.container)}>
			<span className={css(styleSheet.taxAmount)}>${formatCurrency(taxAmount)}</span>
			<button className={css(styleSheet.link, styleSheet.editLink)} onClick={onEditClick} type='button'>
				[edit location]
			</button>
		</span>
	);
}
